import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var breadcrumbs = {
  name: "jwi3ah",
  styles: "display:flex;margin:10px 0 0 16px;"
};
export var upLevel = /*#__PURE__*/css(typography.bodySmall, " display:block;margin:14px 0 0 16px;color:", colors.neutral.medium.default, ";text-decoration:none;");
export var upLevelIcon = {
  name: "41v3li",
  styles: "position:relative;left:-4px;width:16px;height:13px;"
};
export var title = /*#__PURE__*/css("width:100%;height:80px;text-align:center;padding-top:14px;color:", colors.neutral.heavy.default, ";");
export var titleSubheading = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";");
export var titleSubheadingLink = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";&:hover{color:", colors.neutral.medium.hover, ";}");
export var titleSubheadingIcon = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";");
export var pow1 = /*#__PURE__*/css("display:none;", media('>=tablet'), "{display:block;}");
export var browseOptions = {
  name: "1laqxgj",
  styles: "display:block;width:100%;padding:32px 17px 0;"
};
export var browseSuburbs = {
  name: "8atqhb",
  styles: "width:100%;"
};
export var advert = {
  name: "bnab5g",
  styles: "display:block;width:100%;height:250px;margin-top:32px;"
};